module.exports = __webpack_public_path__ + "static/media/logom.ea7d6c51.svg";